import { useTranslation } from 'react-i18next';

// A failed demo must not silently switch to the configured backend.
type MockApiUnavailableProps = { error?: { message?: string } | null };

export function MockApiUnavailable({ error }: MockApiUnavailableProps) {
  const { t } = useTranslation();

  return (
    <main className="startup-error">
      <h1>{t('error.mockApi.title')}</h1>
      <p>{t('error.mockApi.explanation')}</p>
      <p>{t('error.mockApi.hint')}</p>
      {error?.message && (
        <pre className="startup-error-cause">{error.message}</pre>
      )}
    </main>
  );
}
